"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBuyForm = exports.useComputedField = exports.useBuyField = exports.BuyFormContextProvider = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const spu_1 = require("@tencent/tccp-frontend-contract/spu");
const useSubject_1 = require("../_hooks/useSubject");
const buy_form_1 = require("../common/buy-form");
const form_1 = require("../modules/form");
const form_2 = require("../types/form");
exports.BuyFormContextProvider = buy_form_1.BuyFormContext.Provider;
function useBuyField(name, valueType) {
    const { current, onChange: onChangeRoot, errors, formStatus, validateFieldBuilder, messageFactory, } = (0, react_1.useContext)(buy_form_1.BuyFormContext);
    const error = (0, react_1.useMemo)(() => {
        if (errors[name]) {
            return Object.assign(Object.assign({}, errors[name]), { message: messageFactory(errors[name].entity) });
        }
        return undefined;
    }, [errors, messageFactory, name]);
    const status = (0, react_1.useMemo)(() => {
        if (error && formStatus === form_2.FormStatus.INVALID) {
            return 'error';
        }
        if (formStatus === form_2.FormStatus.VALID) {
            return 'success';
        }
        if (formStatus === form_2.FormStatus.VALIDATING) {
            return 'validating';
        }
    }, [error, formStatus]);
    const [value, onChange] = (0, react_1.useMemo)(() => {
        var _a, _b;
        let value = current[name];
        let onChange = (newValue) => onChangeRoot(name, newValue);
        // 根据valueType限制值的类型
        switch (valueType) {
            case spu_1.ValueTypeEnum.Int:
            case spu_1.ValueTypeEnum.Decimal: {
                value = value === undefined ? value : Number(current[name]);
                onChange = (newValue) => onChangeRoot(name, newValue === undefined ? newValue : Number(newValue));
                break;
            }
            case spu_1.ValueTypeEnum.String: {
                value = value === undefined ? value : String(current[name]);
                onChange = (newValue) => onChangeRoot(name, newValue === undefined ? newValue : String(newValue));
                break;
            }
            case spu_1.ValueTypeEnum.IntArray:
            case spu_1.ValueTypeEnum.DecimalArray: {
                value = (_a = current[name]) === null || _a === void 0 ? void 0 : _a.map(Number);
                onChange = (newValue) => onChangeRoot(name, newValue === null || newValue === void 0 ? void 0 : newValue.map(Number));
                break;
            }
            case spu_1.ValueTypeEnum.StringArray: {
                value = (_b = current[name]) === null || _b === void 0 ? void 0 : _b.map(String);
                onChange = (newValue) => onChangeRoot(name, newValue === null || newValue === void 0 ? void 0 : newValue.map(String));
                break;
            }
        }
        return [value, onChange];
    }, [current, name, onChangeRoot, valueType]);
    const validateField = (0, react_1.useMemo)(() => validateFieldBuilder(current, name), [current, name, validateFieldBuilder]);
    return {
        value,
        onChange,
        error,
        status,
        validateField,
    };
}
exports.useBuyField = useBuyField;
function useComputedField(valueGetter) {
    const { current } = (0, react_1.useContext)(buy_form_1.BuyFormContext);
    const computedValue = (0, react_1.useMemo)(() => (typeof valueGetter === 'function' ? valueGetter(current) : undefined), [valueGetter, current]);
    return computedValue;
}
exports.useComputedField = useComputedField;
function useBuyForm() {
    const [status, setStatus, status$] = (0, useSubject_1.useBehaviorSubject)(form_2.FormStatus.INIT);
    const action$ = (0, react_1.useMemo)(() => new rxjs_1.Subject(), []);
    (0, react_1.useEffect)(() => {
        const status_ = (0, rxjs_1.combineLatest)([status$, action$])
            .pipe((0, rxjs_1.map)(([status, action]) => (0, form_1.getNextFormStatus)(status, action)), (0, rxjs_1.distinctUntilChanged)())
            .subscribe({
            next: setStatus,
        });
        return () => {
            status_.unsubscribe();
        };
    }, [action$, setStatus, status$]);
    const dispatch = (0, react_1.useCallback)((next) => {
        action$.next(next);
    }, [action$]);
    const validate = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        const status_ = status$.pipe((0, rxjs_1.skipUntil)(action$.pipe((0, rxjs_1.filter)(action => action === form_2.FormAction.VALIDATE))), (0, rxjs_1.filter)(status => status === form_2.FormStatus.VALID || status === form_2.FormStatus.INVALID));
        const statusPromise = (0, rxjs_1.firstValueFrom)(status_);
        action$.next(form_2.FormAction.VALIDATE);
        return (yield statusPromise) === form_2.FormStatus.VALID;
    }), [action$, status$]);
    const submit = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        const status_ = status$.pipe((0, rxjs_1.skipUntil)(action$.pipe((0, rxjs_1.filter)(action => action === form_2.FormAction.SUBMIT))), (0, rxjs_1.filter)(status => status === form_2.FormStatus.SUBMIT_SUCCESS || status === form_2.FormStatus.SUBMIT_FAILED));
        const statusPromise = (0, rxjs_1.firstValueFrom)(status_);
        action$.next(form_2.FormAction.SUBMIT);
        return (yield statusPromise) === form_2.FormStatus.SUBMIT_SUCCESS;
    }), [action$, status$]);
    return { status, dispatch, status$, validate, submit };
}
exports.useBuyForm = useBuyForm;
